import { render, staticRenderFns } from "./GripAnalysisNavigationTabs.vue?vue&type=template&id=be361c38"
import script from "./GripAnalysisNavigationTabs.vue?vue&type=script&lang=ts"
export * from "./GripAnalysisNavigationTabs.vue?vue&type=script&lang=ts"
import style0 from "./GripAnalysisNavigationTabs.vue?vue&type=style&index=0&id=be361c38&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports